module.exports = __webpack_public_path__ + "img/diamond_principal.7e3a310c.png";